// sort-imports-ignore

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import './main.scss';
import { registerServiceWorker, start } from '@salesforce/pwa-kit-react-sdk/ssr/browser/main';
import 'construct-style-sheets-polyfill/dist/adoptedStyleSheets';
import { setEncryptionSelectors } from './utils/content-square-utils';
import { fixUrlSpaces } from './utils/fix-url-spaces';

setEncryptionSelectors(window);
fixUrlSpaces();

const main = () =>
    // The path to your service worker should match what is set up in ssr.js
    Promise.all([start(), registerServiceWorker('/worker.js')]);
main();
